import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import {  AUTHORIZED_URL_PREFIX, UNIT_BY_ID_URL, AxiosConfig } from '../../Utils/Constants';
import './unitIFrame.css';
import Loading from '../common/Loading';
import { notify, pleaseRefreshError } from '../../Utils/Notificator';

const UnitIFrame = () => {
	const [ isLoading, setIsLoading ] = useState(true);
	const [ s3Url, setS3Url ] = useState([]);
	const { unitId } = useParams();

	useEffect(() => {
		const fetchUnitData = async () => {
			try {
				const { data } = await axios.post(
					`${AUTHORIZED_URL_PREFIX}${UNIT_BY_ID_URL}`,
					{ unitId },
					AxiosConfig()
				);
				if (data.success) {
					setS3Url(data.unit.s3Url);
					setIsLoading(false);
				}else{
					notify(pleaseRefreshError);
				}
			} catch (error) {
				console.error(error);
				notify(pleaseRefreshError);
			}
		};
		fetchUnitData();
	}, []);

	return <div>
		{isLoading ? <Loading /> : <div>
			<div className="lykiocss-unitiframe-iframe">
				<iframe src={s3Url} />
			</div>
		</div>}
	</div>
};

export default UnitIFrame;
